import PaymentGatewayProcessor from './paymentGatewayProcessorAbstract';
import store from '../../store';
import {getSelectedPlan, toggleLoader, handlePromise, getSelectedGatewayOnLoad} from '../../lib';
import {setState} from "../../index";

let state = store.state.cartState ? store.state.cartState : {};

export default class ApplePayGateway extends PaymentGatewayProcessor {
  processCheckout() {
    return new Promise(async (resolve, reject) => {
      try {
        toggleLoader(false);
        const recurlyTokenElement = document.querySelector('#recurly_token');

        if (applePay._ready) {
          // applePay._paymentRequest.total.amount = total_price;
          // applePay._paymentRequest.total.label = getSelectedPlan().name;
          applePay.begin();
        } else {
          reject('An error occured while processing payment from ApplePay! please try again later!');
        }

        applePay.on('token', async token => {
          console.log('Apple Pay token', token);
          toggleLoader(true);
          recurlyTokenElement.value = token.id;
          const [checkoutApiCallRes, checkoutApiCallErr] = await handlePromise(this.checkoutInit());
          if (checkoutApiCallErr) return reject(checkoutApiCallErr);
          resolve(checkoutApiCallRes);
        });

        applePay.on('error', err => {
          console.error('Apple Pay error', err);
          toggleLoader(false);
          reject(err);
        });
      } catch (err) {
        throw reject(err);
      }
    });
  }

  static loadApplePayIfApplicable(GatewaysInstance) {
    // Check if apple pay is attached with any of plan
    let applePayPlans = state.plans.filter(function (plan) {
      let filteredGateways = plan.gateways.filter(function (gateway) {
        return gateway.logical_key.toLowerCase() == 'applepay';
      });

      return filteredGateways.length;
    });

    // Initialize apple pay when its attached with any of plan
    if (applePayPlans.length) {
      applePay = recurly.ApplePay({
        country: 'US',
        currency: state.currency_code,
        label: getSelectedPlan().package_plan_label,
        total: window.total_price || 1,
      });

      applePay.ready(function () {
        console.log('Apple Pay ready');
        conditionalGateways.applepay = true;

        //select Apple Pay if it is the first
        let selectedGateway = getSelectedGatewayOnLoad();
        if (selectedGateway.gateway_key !== state.selected_gateway && selectedGateway.gateway_key === 'applepay') {
          setState({
            selected_gateway: selectedGateway.gateway_key,
            selected_gateway_name: selectedGateway.gateway_name,
          });
        }
        GatewaysInstance.render();
      });
    }
  }
}
